import React, { useState } from 'react'
import logoLight from './images/kiwi-full-logo.svg'
import loginSideGraphic from './images/login_side_graphic.png'

import { Mail, Check, X } from 'react-feather'
import { Link } from 'react-router-dom'
import { Input } from 'reactstrap'
import AxiosInstance from 'utils/AxiosInstance'
import { useDispatch, useSelector } from 'react-redux'

const ForgotPassword = () => {
  const [email, setEmail] = useState('')
  const [emailSent, setEmailSent] = useState(false)
  const { theme } = useSelector((state) => state.themeConfig)

  const data = { email }
  const sendEmail = (e) => {
    e.preventDefault()

    AxiosInstance.post('/users/forgot-password', data).then((response) => {
      if (!response) {
        alert('Something went wrong!')
        return
      }

      if (response.success) {
        setEmailSent(true)
      } else {
        alert(response.message)
      }
    })
  }
  return (
    <div className='modern-login'>
      <div className='underlay d-none d-xl-block'></div>

      <div className='d-flex align-items-center h-100'>
        <div className='d-none d-md-block col-md-6 col-lg-7 col-xl-8 px-0'>
          <div className='hero is-fullheight is-image'>
            <div className='hero-body' style={{ height: '100vh' }}>
              <div className='h-100 d-flex align-items-center'>
                <div className='col'>
                  <img
                    className='hero-image-blur'
                    src={
                      theme.background && theme.background.url
                        ? theme.background.url
                        : loginSideGraphic
                    }
                    alt=''
                    aria-hidden='true'
                  />
                  <img
                    className='hero-image'
                    src={
                      theme.background && theme.background.url
                        ? theme.background.url
                        : loginSideGraphic
                    }
                    alt=''
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='col-md-6  col-lg-5 col-xl-4 px-0 is-relative'>
          <a className='top-logo mt-md-5' href='/'>
            <img
              className='light-image'
              src={
                theme.loginLogo && theme.loginLogo.url
                  ? theme.loginLogo.url
                  : logoLight
              }
              alt=''
            />
            <img
              className='dark-image'
              src='assets/img/logos/logo/logo-light.svg'
              alt=''
            />
          </a>

          <div class='is-form mt-5 px-lg-3'>
            <div class='hero-body'>
              <div class={`form-text ${emailSent && 'text-center'} `}>
                <h2>Recover Account</h2>
                {!emailSent ? (
                  <p className='text-sm'>Reset your account password.</p>
                ) : (
                  <p>
                    Email sent successfully. <br></br> Please check your email.
                  </p>
                )}
              </div>

              <form id='recover-form' class='login-wrapper'>
                {!emailSent && (
                  <>
                    <p class='recover-text text-sm'>
                      Enter your email and click on the confirm button to reset
                      your password. We'll send you an email detailing the steps
                      to complete the procedure.
                    </p>
                    <div className='control has-validation'>
                      <Input
                        type='text'
                        className='input'
                        placeholder=''
                        onChange={(e) => setEmail(e.target.value)}
                      />
                      <small className='error-text'>
                        This is a required field
                      </small>
                      <div className='auth-label'>Email Address</div>
                      <div className='auth-icon'>
                        <Mail />
                      </div>
                      <div className='validation-icon is-success'>
                        <div className='icon-wrapper'>
                          <Check />
                        </div>
                      </div>
                      <div className='validation-icon is-error'>
                        <div className='icon-wrapper'>
                          <X />
                        </div>
                      </div>
                    </div>
                  </>
                )}
                <div
                  class={`button-wrap mt-4 ${emailSent &&
                    'justify-content-center align-content-center d-flex'
                    } `}
                >
                  <Link to='/auth/new-login'>
                    <button
                      id='cancel-recover'
                      type='button'
                      className={`${emailSent
                          ? 'btn text-white login-button blue'
                          : 'login-button confirm'
                        }`}
                      style={{
                        backgroundColor: emailSent && '#00adf2',
                      }}
                    >
                      Login
                    </button>
                  </Link>
                  {!emailSent && (
                    <button
                      type='submit'
                      className='login-button confirm'
                      onClick={sendEmail}
                    >
                      Confirm
                    </button>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ForgotPassword
